<section class="geo-summary-page">
    <mat-drawer-container #flyoutContainer class="geo-flyout-container" [style.height.px]="flyoutContainerHeightPx"
        [style.min-height.px]="flyoutContainerHeightPx" [hasBackdrop]="flyoutProjectId !== null"
        (backdropClick)="closeFlyout()">
        <mat-drawer class="geo-project-flyout" position="end" mode="over" [opened]="flyoutProjectId !== null"
            (openedStart)="onFlyoutOpened()">
            <app-project-display *ngIf="flyoutProject$ && flyoutProjectId !== null" [project$]="flyoutProject$"
                [projectId]="flyoutProjectId"></app-project-display>
        </mat-drawer>
        <mat-drawer-content class="geo-drawer-content" [class.geo-drawer-content-country-selected]="hasCountrySelected">
            <div class="alert alert-danger" role="alert" *ngIf="summaryErrorMessage">{{ summaryErrorMessage }}</div>
            <div class="geo-toolbar-row">
                <div class="geo-toolbar">
                    <label>Sector</label>
                    <mat-radio-group [value]="selectedSectorId" (change)="onSectorChanged($event.value)">
                        <mat-radio-button *ngFor="let sector of sectors" [value]="sector.id">{{ sector.name
                            }}</mat-radio-button>
                    </mat-radio-group>
                </div>
            </div>
            <div class="geo-filter-actions" *ngIf="devLegacyRegionNames.length">
                <!-- Legacy regions text removed -->
            </div>
            <div class="geo-summary-flex-layout">
                <div class="geo-summary-flex-left">
                    <div class="geo-summary-card geo-summary-card-map">
                        <div class="geo-card-header geo-card-header-map">
                            <div class="geo-card-title">{{ mapTitle }}</div>
                            <div class="geo-map-header-actions">
                                <button mat-stroked-button type="button" *ngIf="canGoBackToEurope"
                                    (click)="backToEuropeMap()">
                                    <mat-icon>arrow_back</mat-icon>
                                    Back to Region
                                </button>
                                <button mat-stroked-button type="button" *ngIf="selectedRegionId"
                                    (click)="clearRegionSelection()">
                                    <mat-icon>public</mat-icon>
                                    Back to World
                                </button>
                            </div>
                        </div>
                        <div class="geo-card-content">
                            <app-eic-d3-map [geometry]="mapGeometry" [regionGeometry]="mapRegionGeometry"
                                [fills]="mapFills"
                                [drilldownGeometry]="isUkConstituentDrilldown ? ukDrilldownGeometry : null"
                                [nonInteractiveCountryIds]="isUkConstituentDrilldown ? ukNonInteractiveCountryIds : []"
                                [selectedRegionId]="selectedRegionId"
                                [selectedCountryId]="isUkConstituentDrilldown ? selectedUkConstituentId : selectedCountryId"
                                (regionSelected)="onRegionSelected($event.eicRegionId)"
                                (countrySelected)="onCountrySelected($event)">
                            </app-eic-d3-map>
                            <app-map-legend [title]="'Capex range'" [minLabel]="legendMinLabel"
                                [maxLabel]="legendMaxLabel"></app-map-legend>
                        </div>
                    </div>
                    <ng-container *ngIf="hasCountrySelected">
                        <div class="geo-summary-card geo-summary-card-chart">
                            <div class="geo-card-header">
                                <div class="geo-card-title">Chart</div>
                            </div>
                            <div class="geo-card-content">
                                <div class="alert alert-danger" role="alert" *ngIf="chartErrorMessage">{{
                                    chartErrorMessage
                                    }}
                                </div>
                                <app-geographical-summary-chart [points]="chartPoints"
                                    (pointSelected)="onChartPointSelected($event)"></app-geographical-summary-chart>
                                <div class="geo-filter-actions" *ngIf="activeChartFilter">
                                    <button type="button" class="btn btn-default" (click)="clearChartFilter()">Clear
                                        chart
                                        filter</button>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>
                <ng-container *ngIf="hasCountrySelected">
                    <div class="geo-summary-flex-right">
                        <div class="geo-summary-card geo-summary-card-summary">
                            <div class="geo-card-header">
                                <div class="geo-card-title">Country Summary</div>
                            </div>
                            <div class="geo-card-content">
                                <app-country-summary-card [country]="selectedCountry"></app-country-summary-card>
                            </div>
                        </div>
                        <div class="geo-summary-card geo-summary-card-projects">
                            <div class="geo-card-header">
                                <div class="geo-card-title">Projects</div>
                            </div>
                            <div class="geo-card-content">
                                <div class="alert alert-danger" role="alert" *ngIf="projectsErrorMessage">{{
                                    projectsErrorMessage }}</div>
                                <div #projectsListScroll class="geo-projects-list-scroll"
                                    [style.max-height.px]="projectsListMaxHeightPx">
                                    <app-geographical-projects-list [projects]="projects"
                                        (projectSelected)="onProjectSelected($event)"></app-geographical-projects-list>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </mat-drawer-content>
    </mat-drawer-container>
</section>